import React, { Fragment, useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import parse from "html-react-parser";

import _API from "@util/api";
import _CK from "@util/cookie";

import { AppContext } from "@component/AppProvider";

export default (props) => {
    const { site, t, iam } = useContext(AppContext);
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    const { code1, code2, code3 } = useParams();

    const loadContent = () => {
        _API.get({ path: "/site/content", data: { code1, code2, code3 } })
            .then((res) => {
                if (res.data) {
                    if (res.data.isMember === "Y" && !_CK.isLogin()) {
                        navigate("/");
                    } else {
                        setData(res.data);
                    }
                } else {
                    navigate("/");
                }
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => (document.location.href = process.env.FRONT_URL));
            });
    };

    useEffect(() => {
        if (code1) {
            loadContent();
        }
    }, [code1, code2, code3]);

    if (data?.content) {
        return parse(data?.content);
    }

    return <Fragment />;
};
